module.exports = __webpack_public_path__ + "img/aws-seeklogo.com.83b76b56.svg";